import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"



const Popupdialog = ({ oncancel, onsuccess, toptext, question, successtext }) => {

    return (
        <Dialog
            open={true}
            onClose={() => oncancel()}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {toptext}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => oncancel()}>
                    Cancel
                </Button>
                <Button onClick={() => onsuccess()}>{successtext}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default Popupdialog